/** @param {object} m @param {object} handlers */
export function buildMainChatLayoutProps(m, handlers) {
  return {
    showChatThread: m.activePrimaryKey === 'home' && Boolean(m.displayThreadId),
    messages: m.activeMessages,
    onSendMessage: m.activePrimaryKey === 'home' ? handlers.handleSendMessage : undefined,
    chatComposerLocked: m.chatComposerLocked,
    activeThreadId: m.displayThreadId,
    activeQueryVersionByExchangeId: m.activeQueryVersionByExchangeId,
    activeAnswerVersionByExchangeId: m.activeAnswerVersionByExchangeId,
    onSetExchangeActiveQueryVersion: handlers.setExchangeActiveQueryVersion,
    onSetExchangeActiveAnswerVersion: handlers.setExchangeActiveAnswerVersion,
    onSendEditVersion: handlers.handleSendEditVersion,
    onRegenerateAssistantVersion: handlers.handleRegenerateAssistantVersion,
    mainAskBarPrefill: m.mainAskBarPrefill,
    onMainAskBarPrefill: handlers.handleMainAskBarPrefill,
    agentQuestion: handlers.activeAgentQuestion,
    onAgentQuestionConfirm: handlers.onAgentQuestionConfirm,
  }
}
